import React, { useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const Header = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <Navbar expand="md">
        <NavbarBrand href="/">Business Values Services</NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            <NavItem>
              <NavLink href="/">Home</NavLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Services
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem href="/">What we offer</DropdownItem>
                <DropdownItem href="/">Hybrid Integration</DropdownItem>
                <DropdownItem href="/">
                  Digital Business Automation
                </DropdownItem>
                <DropdownItem href="/">
                  B2B &amp; File Transfer Solutions
                </DropdownItem>
                <DropdownItem href="/">IBM Cloud Pak</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <NavItem>
              <NavLink href="/">Partners</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/">Our Frameworks</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/">Added Business Value Solution</NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default Header;
